import { shopifyLogIn, shopifyAuthResult } from '../helpers/restHelpers'

export const logInAction = (queryString) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        dispatch({ type: 'SHOPIFY_LOGIN' })
        shopifyLogIn(queryString)
            .then((response) => {
                dispatch({ type: 'SHOPIFY_LOGIN_SUCCESS', payload: response })

                resolve(response.data)
            })
            .catch((error) => {
                dispatch({ type: 'SHOPIFY_LOGIN_FAILURE', payload: error })
                reject(error)
            })
    })

export const authResultAction = (qString) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        dispatch({ type: 'SHOPIFY_AUTHRESULT' })
        shopifyAuthResult(qString)
            .then((response) => {
                dispatch({
                    type: 'SHOPIFY_AUTHRESULT_SUCCESS',
                    payload: response,
                })
                resolve(response.data)
            })
            .catch((error) => {
                dispatch({ type: 'SHOPIFY_AUTHRESULT_FAILURE', payload: error })
                reject(error)
            })
    })
